<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :prepend-icon="outlined ? undefined : 'mdi-calendar'"
        :prepend-inner-icon="outlined ? 'mdi-calendar' : undefined"
        :outlined="outlined"
        :dense="dense"
        :hide-details="hideDetails"
        readonly
        :value="formatDate"
        v-on="on"
        :disabled="disabled"
      />
    </template>
    <v-date-picker v-model="date" scrollable :min="min" :max="max">
      <v-spacer />
      <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'DatePicker',
  props: ['value', 'label', 'min', 'max', 'disabled', 'outlined', 'dense', 'hideDetails'],
  data() {
    return {
      modal: false,
      date: this.value || '',
    };
  },
  computed: {
    formatDate() {
      return this.$localDate(this.date);
    },
  },
  methods: {
    mutate() {
      this.$emit('input', this.date);
    },
    setForm(value) {
      this.$set(this, 'date', value);
    },
  },
  watch: {
    date: 'mutate',
    value: 'setForm',
  },
};
</script>

<style scoped></style>
